import React, { Component } from 'react';
import { Switch, withRouter, Router, Route } from 'react-router-dom';

import '../../index.css';

import Privacy from './Privacy';
import Terms from './Terms';
import Account from './Account';
import Complete from './Complete';
import Header from '../../components/Header';
import LeftTab from '../../components/LeftTab';
import SelectShopPage from './SelectShopPage';

function SignUp({ location }) {
  const curPath = location.pathname;

  return (
    <div className="App">
      <Header />
      <div style={{ backgroundColor: '#DDDDDD', paddingBottom: 31 }}>
        <div
          style={{
            paddingTop: 31,
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <LeftTab url={curPath} />
          <div className={'content-box'}>
            <Switch>
              <Route path="/signup/privacy" component={Privacy} />
              <Route path="/signup/terms" component={Terms} />
              <Route path="/signup/account" component={Account} />
              <Route path="/signup/select-shop" component={SelectShopPage} />
              <Route path="/signup/complete" component={Complete} />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(SignUp);
